export const SIGN_AND_ATTACH = 'sign_and_attach';
export const COMPLETE_AND_ATTACH = 'complete_and_attach';
export const ATTACH = 'attach';
